module.exports = __webpack_public_path__ + "static/media/image_64.46a17961.png";